import { useApplicantData } from './useApplicantData';
import { getApplicantData } from '../util/helpers/applicantDataHelper';

const useApplicationOwnerName = (applicantType) => {
  const ApplicantData = useApplicantData(applicantType);

  const applicantName = getApplicantData(
    ApplicantData,
    'PersonName',
    'FirstName',
  );
  return applicantName || '';
};

export default useApplicationOwnerName;
